<template>
  <div class="ovg-page">
    <div class="ovg-page__bg" aria-hidden="true" />

    <!-- Header -->
    <header class="ovg-header">
      <div
        class="ovg-header__logos"
        @click="$router.push({ name: 'ovg-landing' })"
      >
        <img
          src="@/assets/logo_original.svg"
          alt="Samtek"
          class="ovg-header__logo-samtek"
        />
        <img
          src="@/assets/logo_asus.png"
          alt="ASUS"
          class="ovg-header__logo-asus"
        />
      </div>
      <button
        class="ovg-header__salir"
        @click="$router.push({ name: 'ovg-landing' })"
      >
        Salir <font-awesome-icon icon="sign-out-alt" />
      </button>
    </header>

    <!-- Sub-header -->
    <div class="ovg-subheader">
      <div class="ovg-subheader__inner">
        <h2 class="ovg-subheader__title">
          Adquiere tu Extensión de Garantía Oficial
        </h2>
        <p class="ovg-subheader__subtitle">
          Asegura la vida útil de tu equipo por más tiempo.<br />
          Completa tus datos personales para asociar la cobertura a tu nombre.
        </p>
      </div>
    </div>

    <!-- Form card -->
    <div class="ovg-content">
      <div class="ovg-card">
        <!-- Mobile progress bar (hidden on desktop) -->
        <div class="ovg-progress">
          <div class="ovg-progress__track">
            <div class="ovg-progress__fill" style="width: 25%" />
          </div>
          <span class="ovg-progress__label">Paso Actual: Tus Datos</span>
        </div>

        <!-- Step indicator (hidden on mobile) -->
        <div class="ovg-steps">
          <div class="ovg-step ovg-step--active">
            <span class="ovg-step__num">1</span>
            <span class="ovg-step__label">Tus Datos</span>
          </div>
          <div class="ovg-step">
            <span class="ovg-step__num">2</span>
            <span class="ovg-step__label">Tu Equipo</span>
          </div>
          <div class="ovg-step">
            <span class="ovg-step__num">3</span>
            <span class="ovg-step__label">Ext. Garantía</span>
          </div>
          <div class="ovg-step">
            <span class="ovg-step__num">4</span>
            <span class="ovg-step__label">Protección Adicional</span>
          </div>
        </div>

        <form @submit.prevent="siguiente">
          <!-- RUT -->
          <div class="ovg-row">
            <div class="ovg-field ovg-field--half">
              <label class="ovg-label">RUT*</label>
              <input
                v-model="form.rut"
                type="text"
                placeholder="12.345.678-9"
                class="ovg-input"
                :class="{
                  'ovg-input--error': $v.form.rut.$dirty && $v.form.rut.$error,
                }"
                @input="onRutInput"
              />
              <span
                v-if="$v.form.rut.$dirty && !$v.form.rut.required"
                class="ovg-error"
                >El RUT es requerido</span
              >
              <span
                v-else-if="$v.form.rut.$dirty && !$v.form.rut.rutValido"
                class="ovg-error"
                >El RUT ingresado no es válido</span
              >
            </div>
          </div>

          <!-- Nombre + Apellido -->
          <div class="ovg-row">
            <div class="ovg-field">
              <label class="ovg-label">Nombre*</label>
              <input
                v-model="form.nombre"
                type="text"
                class="ovg-input"
                :class="{
                  'ovg-input--error':
                    $v.form.nombre.$dirty && $v.form.nombre.$error,
                }"
                @blur="$v.form.nombre.$touch()"
              />
              <span
                v-if="$v.form.nombre.$dirty && !$v.form.nombre.required"
                class="ovg-error"
                >El nombre es requerido</span
              >
            </div>
            <div class="ovg-field">
              <label class="ovg-label">Apellido*</label>
              <input
                v-model="form.apellido"
                type="text"
                class="ovg-input"
                :class="{
                  'ovg-input--error':
                    $v.form.apellido.$dirty && $v.form.apellido.$error,
                }"
                @blur="$v.form.apellido.$touch()"
              />
              <span
                v-if="$v.form.apellido.$dirty && !$v.form.apellido.required"
                class="ovg-error"
                >El apellido es requerido</span
              >
            </div>
          </div>

          <!-- Correo + Teléfono -->
          <div class="ovg-row">
            <div class="ovg-field">
              <label class="ovg-label">Correo Electrónico*</label>
              <input
                v-model="form.correo"
                type="text"
                placeholder="ej:correo@mail.cl"
                class="ovg-input"
                :class="{
                  'ovg-input--error':
                    $v.form.correo.$dirty && $v.form.correo.$error,
                }"
                @blur="$v.form.correo.$touch()"
              />
              <span
                v-if="$v.form.correo.$dirty && !$v.form.correo.required"
                class="ovg-error"
                >El correo es requerido</span
              >
              <span
                v-else-if="$v.form.correo.$dirty && !$v.form.correo.email"
                class="ovg-error"
                >Ingresa un correo válido</span
              >
            </div>
            <div class="ovg-field">
              <label class="ovg-label">Teléfono*</label>
              <input
                v-model="form.telefono"
                type="text"
                class="ovg-input"
                :class="{
                  'ovg-input--error':
                    $v.form.telefono.$dirty && $v.form.telefono.$error,
                }"
                @blur="$v.form.telefono.$touch()"
              />
              <span
                v-if="$v.form.telefono.$dirty && !$v.form.telefono.required"
                class="ovg-error"
                >El teléfono es requerido</span
              >
            </div>
          </div>

          <!-- Submit -->
          <div class="ovg-card__footer">
            <button type="submit" class="ovg-btn ovg-btn--primary">
              Siguiente Paso
            </button>
          </div>
        </form>
      </div>

      <resumen-solicitud-panel />
    </div>

    <!-- Mobile bottom bar + sheet (hidden on desktop) -->
    <ovg-resumen-mobile-bar />

    <!-- Contact button (WhatsApp): oculto hasta que el negocio lo habilite
    <a
      href="https://wa.me"
      class="ovg-contact-btn"
      target="_blank"
      rel="noopener"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path :d="waSvgPath" />
      </svg>
    </a>
    -->

    <p class="ovg-page__footer">
      © 2026 Samtek | Servicio Técnico ASUS Autorizado en Chile.
    </p>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import isValidRut from '@/utils/validateRut'
import ResumenSolicitudPanel from '@/components/OVG/ResumenSolicitudPanel.vue'
import OvgResumenMobileBar from '@/components/OVG/OvgResumenMobileBar.vue'

export default {
  name: 'ClienteFormView',
  components: {
    ResumenSolicitudPanel,
    OvgResumenMobileBar,
  },
  data() {
    return {
      waSvgPath:
        // eslint-disable-next-line max-len
        'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z',
      form: {
        rut: '',
        nombre: '',
        apellido: '',
        correo: '',
        telefono: '',
      },
    }
  },
  validations: {
    form: {
      rut: {
        required,
        rutValido: (val) => !val || isValidRut(val),
      },
      nombre: { required },
      apellido: { required },
      correo: { required, email },
      telefono: { required },
    },
  },
  created() {
    const cliente = this.$store.getters['OVGStore/cliente']
    if (cliente) {
      this.form = { ...this.form, ...cliente }
    }
  },
  methods: {
    onRutInput(e) {
      const raw = e.target.value.replace(/[^\dkK]/g, '').toUpperCase()
      if (raw.length < 2) {
        this.form.rut = raw
      } else {
        const dv = raw.slice(-1)
        const num = raw.slice(0, -1)
        this.form.rut = `${num}-${dv}`
      }
      this.$v.form.rut.$touch()
    },
    siguiente() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.$store.commit('OVGStore/SET_CLIENTE', { ...this.form })
      this.$router.push({ name: 'ovg-modelo' })
    },
  },
}
</script>

<style scoped>
.ovg-page {
  font-family: 'Noto Sans', sans-serif;
  min-height: 100vh;
  background-color: #f5f6fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 80px;
}

.ovg-page__bg {
  /* Sin `opacity`: el PNG ya es una marca de agua (su patrón viene con
     alpha 13/255). Desvanecerlo otra vez acá lo dejaba en 0,62% de
     contraste, o sea invisible en pantalla. */
  position: fixed;
  inset: 0;
  background-image: url('~@/assets/fondo_samtek.png');
  background-size: cover;
  background-position: center;
  pointer-events: none;
  z-index: 0;
}

/* Header */
.ovg-header {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 55px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 162px;
  flex-shrink: 0;
}

.ovg-header__logos {
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
}

.ovg-header__logo-samtek {
  height: 18px;
  width: auto;
}

.ovg-header__logo-asus {
  height: 18px;
  width: auto;
}

.ovg-header__salir {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #23201c;
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
}

/* Sub-header */
.ovg-subheader {
  position: relative;
  z-index: 1;
  width: 100%;
  background: #0a192f;
  min-height: 195px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 20px;
  text-align: left;
}

/* Alinea el texto con el borde izquierdo de la card del formulario. */
.ovg-subheader__inner {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 1207px;
  max-width: calc(100% - 40px);
}

.ovg-subheader__title {
  font-size: 28px;
  font-weight: 700;
  color: #f5f6fa;
  margin: 0;
}

.ovg-subheader__subtitle {
  font-size: 15px;
  font-weight: 400;
  color: #f5f6fa;
  margin: 0;
  line-height: 1.5;
}

/* Content: card + side panel */
.ovg-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  width: 1207px;
  max-width: calc(100% - 40px);
  margin-top: -20px;
}

.ovg-content >>> .ovg-resumen {
  position: sticky;
  top: 20px;
}

/* Card */
.ovg-card {
  position: relative;
  z-index: 1;
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  width: 827px;
  flex-shrink: 0;
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 24px;
}

@media (max-width: 1247px) {
  .ovg-content {
    flex-direction: column;
    align-items: center;
    width: 827px;
  }

  .ovg-subheader__inner {
    width: 827px;
  }

  .ovg-content >>> .ovg-resumen {
    position: static;
    width: 100%;
  }
}

/* Steps */
.ovg-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.ovg-step {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ovg-step__num {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 60px;
  background: #f5f6fa;
  color: #525252;
  font-size: 18px;
  font-weight: 700;
  flex-shrink: 0;
}

.ovg-step__label {
  font-size: 20px;
  font-weight: 700;
  color: #525252;
  white-space: nowrap;
}

.ovg-step--active .ovg-step__num {
  background: #fece2f;
  color: #23201c;
  font-size: 15px;
}

.ovg-step--active .ovg-step__label {
  color: #23201c;
}

/* Form layout */
form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Form fields */
.ovg-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.ovg-row {
  display: flex;
  gap: 20px;
}

/* Campo que ocupa media fila: mismo ancho que Nombre/Apellido. */
.ovg-field--half {
  flex: 0 0 calc(50% - 10px);
  max-width: calc(50% - 10px);
}

.ovg-label {
  font-size: 15px;
  font-weight: 700;
  color: #23201c;
  margin: 0;
}

.ovg-input {
  height: 45px;
  border: 1px solid #525252;
  border-radius: 5px;
  padding: 0 10px;
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  color: #23201c;
  background: #ffffff;
  width: 100%;
  outline: none;
  transition: border-color 0.15s;
}

.ovg-input::placeholder {
  color: #525252;
  font-weight: 400;
}

.ovg-input:focus {
  border-color: #fece2f;
}

.ovg-input--error {
  border-color: #dc3545;
}

.ovg-error {
  font-size: 13px;
  color: #dc3545;
  margin-top: 2px;
}

/* Card footer */
.ovg-card__footer {
  display: flex;
  justify-content: flex-end;
}

/* Mobile progress bar — oculto en desktop */
.ovg-progress {
  display: none;
}

.ovg-progress__track {
  width: 100%;
  height: 8px;
  background: #e3e3e3;
  border-radius: 4px;
  overflow: hidden;
}

.ovg-progress__fill {
  height: 100%;
  background: #fece2f;
  border-radius: 4px;
}

.ovg-progress__label {
  font-size: 14px;
  font-weight: 400;
  color: #525252;
}

/* Shared button */
.ovg-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  padding: 10px 20px;
  border-radius: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: opacity 0.15s;
}

.ovg-btn:hover {
  opacity: 0.9;
}

.ovg-btn--primary {
  background: #fece2f;
  color: #23201c;
}

/* Contact button */
.ovg-contact-btn {
  position: fixed;
  bottom: 90px;
  right: 70px;
  z-index: 10;
  width: 45px;
  height: 45px;
  background: #fece2f;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #23201c;
  font-size: 20px;
  text-decoration: none;
}

/* Page footer */
.ovg-page__footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  font-size: 15px;
  font-weight: 400;
  color: #23201c;
  text-align: center;
  margin: 0;
  padding: 12px 0;
  border-top: 1px solid #d2d2d2;
  background: #f5f6fa;
}

/* ============================================================
   MOBILE — max-width: 767px
   ============================================================ */
@media (max-width: 767px) {
  /* Page */
  .ovg-page {
    padding-bottom: 100px;
  }

  /* Header */
  .ovg-header {
    padding: 0 20px;
  }

  /* Sub-header */
  .ovg-subheader {
    min-height: auto;
    padding: 24px 20px;
  }

  .ovg-subheader__inner {
    width: 100%;
  }

  .ovg-subheader__title {
    font-size: 24px;
  }

  .ovg-subheader__subtitle {
    font-size: 14px;
  }

  /* Content */
  .ovg-content {
    width: 100%;
    max-width: 100%;
    margin-top: -20px;
    padding: 0 20px;
    flex-direction: column;
  }

  /* Ocultar panel resumen lateral */
  .ovg-content >>> .ovg-resumen {
    display: none;
  }

  /* Card */
  .ovg-card {
    width: 100%;
    max-width: 375px;
    margin: 0 auto;
    border-radius: 16px;
    padding: 20px;
  }

  /* Desktop step indicator → oculto */
  .ovg-steps {
    display: none;
  }

  /* Mobile progress bar → visible */
  .ovg-progress {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  /* Form rows → columna */
  .ovg-row {
    flex-direction: column;
    gap: 16px;
  }

  /* Campo mitad → ocupa todo el ancho */
  .ovg-field--half {
    flex: 1;
    max-width: 100%;
  }

  /* Botón Siguiente → ancho completo y azul marino */
  .ovg-card__footer {
    justify-content: stretch;
  }

  .ovg-card__footer .ovg-btn {
    width: 100%;
    background: #203859;
    color: #ffffff;
  }

  /* Footer de página → oculto en mobile (lo reemplaza el bottom bar) */
  .ovg-page__footer {
    display: none;
  }
}
</style>
